<div class="container">
    <ah-user-details [userInfo]="userInfo$ | async" (onSubmitDetails)="proceed($event)"></ah-user-details>
</div>